export const MAX_STACK_TRACE_SIZE_BYTES = 32 * 1024;
//# sourceMappingURL=constants.js.map